import React from 'react';
import FlexLayout from '../FlexLayout';
import Text from '../Text';
import * as Barcode from 'react-barcode';

const fontSize = '18px';

const blackVerticalAlign = {
  color: 'white',
  background: 'black',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  fontSize: fontSize,
  fontWeight: 600
}

const whiteVerticalAlign = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  padding: '1.5px',
  fontSize: fontSize,
  fontWeight: 600
}

const section = {
  border: '1px solid black',
  borderBox: 'content-box',
}

const bold = {
  fontWeight: 600,
  fontSize: '20px',
}

function ReceivementFreshPendencyLabel({ obj, style }) {
  return (
    <FlexLayout direction="column" style={{ ...style, maxWidth: '11cm', maxHeight: '9cm', border: '1px solid black' }}>
      <FlexLayout name="warehouse-header" align="stretch" justify="around" style={section}>
        <Text plainText={`${obj.shed}`} style={{ ...blackVerticalAlign, ...bold, height: 'auto' }} />
        <FlexLayout name="address-barcode-header" direction="column" align="center" style={{ minWidth: '80%' }}>
          <Text text="label.addressBarcode" />
          <FlexLayout justify="center">
            <Barcode value={obj.address} displayValue={false} format="CODE128" width={1.0} height={30} marginTop={2} marginBottom={7} />
          </FlexLayout>
        </FlexLayout>
      </FlexLayout>

      <FlexLayout style={section}>
        <FlexLayout name="pendency-id-container" direction="column" style={{ width: '40%' }}>
          <Text text="label.pendencyId" style={blackVerticalAlign} />
          <Text plainText={obj.pendencyId} style={blackVerticalAlign} />
        </FlexLayout>
        <FlexLayout name="address-container" direction="column">
          <Text text="label.address" style={{ ...blackVerticalAlign, width: '100%' }} />
          <Text plainText={obj.address} style={{ ...blackVerticalAlign, width: '100%' }} />
        </FlexLayout>
      </FlexLayout>

      <Text plainText={obj.status === "ENDEREÇO INVÁLIDO" ? obj.description : "PRODUTO NÃO CADASTRADO"} style={{ ...blackVerticalAlign, ...bold, fontSize: '20px' }} />

      <FlexLayout style={section}>
        <FlexLayout direction="column">
          <FlexLayout name="entry-expiration-container" justify="around" style={section}>
            <Text text="label.entry" style={{ ...blackVerticalAlign }} />
            <Text plainText={obj.entryDate} style={{ ...whiteVerticalAlign, textAlign: 'center' }} />
            <Text text="label.expirationDate" style={blackVerticalAlign} />
            <Text plainText={obj.expirationDate} style={whiteVerticalAlign} />
          </FlexLayout>
          <FlexLayout name="barcode-sku-container" direction="column" align="center" justify="center" style={section}>
            <Text text="label.barcodeSku" style={{fontSize: fontSize}}/>
            <FlexLayout justify="center">
              <Barcode value={obj.barcode} fontSize={13} format="CODE39" width={1.0} height={30} marginTop={3} marginBottom={6} />
            </FlexLayout>
          </FlexLayout>
        </FlexLayout>
      </FlexLayout>
    </FlexLayout>
  );
}

export default ReceivementFreshPendencyLabel;